import { purify } from '@vfit/shared/themes';
import * as S from './banner.style';
import { IBanner } from './banner.models';
import { sunrisePrimitives, theme } from '@vfit/shared/themes';

const Banner = ({
  color = sunrisePrimitives.cyanDark,
  textColor = theme.colors.text.inverse,
  text,
}: IBanner) => {
  const [pText] = purify([text]);
  return (
    <S.Container color={color} textColor={textColor} className="Banner-Top-ShoppingCart">
      {pText && (
        <div
          dangerouslySetInnerHTML={{
            __html: pText,
          }}
        />
      )}
    </S.Container>
  );
};

export default Banner;

